import { STAGES, formatTime, loadBest } from '../stages/stages';

export interface StageSelectCallbacks {
  onPick(index: number): void;
  onBack(): void;
}

const BTN_GHOST =
  'display:block;width:100%;margin:10px 0 0;padding:9px 14px;font-size:14px;' +
  'color:#e8e8ef;background:transparent;border:1px solid rgba(232,232,239,0.35);border-radius:10px;cursor:pointer;';

/** Grid 6 stage tantangan (single player). */
export class StageSelect {
  private root: HTMLDivElement;

  constructor(private panel: HTMLElement, private cb: StageSelectCallbacks) {
    this.root = document.createElement('div');
    this.root.style.cssText = 'width:min(460px,94vw);';

    const title = document.createElement('h1');
    title.style.cssText = 'text-align:center;font-size:22px;letter-spacing:2px;margin-bottom:2px;';
    title.textContent = 'PILIH STAGE';
    this.root.appendChild(title);
    const hint = document.createElement('div');
    hint.style.cssText = 'text-align:center;font-size:12px;opacity:0.6;margin-bottom:10px;';
    hint.textContent = 'Seret crate ke pad finish untuk menyelesaikan stage';
    this.root.appendChild(hint);

    const grid = document.createElement('div');
    grid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;';
    STAGES.forEach((def, i) => {
      const card = document.createElement('button');
      card.style.cssText =
        'text-align:left;padding:12px;border-radius:10px;cursor:pointer;color:#e8e8ef;' +
        'background:rgba(255,255,255,0.06);border:1px solid rgba(93,255,212,0.35);';
      const best = loadBest(i);
      card.innerHTML =
        `<div style="font-size:11px;opacity:0.55;letter-spacing:1px;">STAGE ${i + 1}</div>` +
        `<div style="font-size:15px;font-weight:700;margin:2px 0;">${def.name}</div>` +
        `<div style="font-size:11px;opacity:0.55;margin-top:4px;">Terbaik: ${best === null ? '—' : formatTime(best)}</div>`;
      card.onmouseenter = () => {
        card.style.borderColor = '#5dffd4';
        card.style.background = 'rgba(93,255,212,0.10)';
      };
      card.onmouseleave = () => {
        card.style.borderColor = 'rgba(93,255,212,0.35)';
        card.style.background = 'rgba(255,255,255,0.06)';
      };
      card.onclick = () => this.cb.onPick(i);
      grid.appendChild(card);
    });
    this.root.appendChild(grid);

    const back = document.createElement('button');
    back.style.cssText = BTN_GHOST;
    back.textContent = 'Kembali';
    back.onclick = () => this.cb.onBack();
    this.root.appendChild(back);

    this.panel.appendChild(this.root);
  }

  dispose(): void {
    this.root.remove();
  }
}
